import { useRoutes } from 'react-router-dom';
import TransparentHeaderRoutes from './transparent-header-routes';
import BasicHeaderRoutes from './basic-header-routes';
import AdminRoutes from './admin-routes';

const Routes = () => {
	return useRoutes([AdminRoutes, TransparentHeaderRoutes, BasicHeaderRoutes]);
};

export default Routes;
